import { render, staticRenderFns } from "./LandingChristmasFR.vue?vue&type=template&id=1e6e7a66&scoped=true"
import script from "./LandingChristmasFR.vue?vue&type=script&lang=js"
export * from "./LandingChristmasFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e7a66",
  null
  
)

export default component.exports